import { Injectable } from '@angular/core';
import { FingerprintjsProAngularService } from '@fingerprintjs/fingerprintjs-pro-angular';
import { Observable, from, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

interface VisitorData {
  sealedResult: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class FingerprintService {
  constructor(private fingerprintjsPro: FingerprintjsProAngularService) {}

  /**
   * Gets the visitor data and returns it as an Observable
   * @returns Observable of the visitor data containing the sealed result (null if there's an error)
   */
  getVisitorData(): Observable<VisitorData> {
    // q: should we be using defer here to get it each time?
    return from(this.fingerprintjsPro.getVisitorData()).pipe(
      map((data) => ({ sealedResult: data.sealedResult })),
      catchError((error) => {
        console.error('Error getting fp data:', error);
        return of({ sealedResult: null });
      })
    );
  }
}
